module.exports = __webpack_public_path__ + "static/icomoon.bd7cdae5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.ttf
// module id = 321
// module chunks = 114276838955818